export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

export const UTM8N = "+proj=utm +zone=8 +datum=WGS84 +units=m +no_defs";
export const WGS84 = "+proj=longlat +datum=WGS84 +no_defs";

export const MODEL_OFFSETS = {
  OFFSET_E: -200,
  OFFSET_N: 1050,
  OFFSET_Z: -830,
  YAW_DEG: 55,
};
